// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProject_wrapper__js3E3"};